import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { c as n } from "../index-C3-ZVs5E.js";
import { Select as h } from "../shared/select/Select.component.js";
import { SelectSizeEnum as x, SelectThemeEnum as f } from "../shared/select/types.js";
import { useMemo as u, useCallback as v } from "react";
const k = ({
  langOptions: a,
  onLangChange: m,
  privacyPolicyUrl: i,
  currentLang: c,
  imprintUrl: s,
  termsOfServiceUrl: l,
  copies: t
}) => {
  const o = u(
    () => a.find((p) => p.value === c),
    [a, c]
  ), d = v(
    (p) => {
      m((p == null ? void 0 : p.value) ?? "");
    },
    [m]
  );
  return /* @__PURE__ */ r("div", { className: "app:flex app:justify-between app:items-center app:pt-6 app:pb-2 app:md:pb-0", children: [
    /* @__PURE__ */ e(
      h,
      {
        theme: f.primary,
        size: x.md,
        className: n(
          "app:w-auto",
          "app:[--select--font-size--md:12px]",
          "app:md:[--select--font-size--md:0.875rem]",
          "app:[--select--icon--padding:0px_12px_0px_4px]",
          "app:[--select--icon--width:12px]",
          "app:[--select--chevron--color:--alpha(var(--app-color-muted)/50%)]",
          "app:[--select--border-color:--alpha(var(--app-color-primary)/10%)]"
        ),
        value: o,
        options: a,
        onChange: d
      }
    ),
    /* @__PURE__ */ r("div", { className: "app:text-muted app:text-[10px] app:md:text-sm", children: [
      /* @__PURE__ */ r("div", { className: "app:underline app:flex app:gap-3", children: [
        /* @__PURE__ */ e("a", { href: s, className: "app:text-muted", children: t.imprintLink }),
        /* @__PURE__ */ e("a", { href: l, className: "app:text-muted", children: t.termsOfServiceLink }),
        /* @__PURE__ */ e("a", { href: i, className: "app:text-muted", children: t.privacyPolicyLink })
      ] }),
      /* @__PURE__ */ e("div", { className: "app:mt-1.5 app:text-right", children: "Copyright © 2025, graphapi®" })
    ] })
  ] });
};
export {
  k as AuthFooter
};
